export const CampaignState = {
  All: -1,
  ToVerify: 200,
  Approved: 210,
  InProgress: 220,
  Completed: 230,
  Refused: 240,
  ToPay: 270,
};

export const formatCampaignState = (stato: number) => {
  switch (stato) {
    case CampaignState.ToVerify:
      return 'In attesa';
    case CampaignState.Approved:
      return 'Approvata';
    case CampaignState.InProgress:
      return 'In corso';
    case CampaignState.Completed:
      return 'Conclusa';
    case CampaignState.Refused:
      return 'Da risolvere';
    case CampaignState.ToPay:
      return 'Da pagare';
    default:
      return 'Sconosciuto';
  }
};
